// Login.js
import React, { useState } from 'react';
import './Login.css';

function Login({ onLoginSuccess }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage('Attempting login...');

   try {
      // Build the URL using the environment variable
      const apiUrl = `${process.env.REACT_APP_API_URL}/api.php?path=login`;

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });

      const result = await response.json(); // Use 'result' to avoid confusion

      if (response.ok && result.success) {
        // --- THIS IS THE FIX ---
        // We access the user and token from inside result.data
        const { user, token } = result.data;
        console.log('Full login response:', result);
console.log('User object from backend:', user);

        setMessage(`Login successful! Welcome, ${user.name}.`);
        localStorage.setItem('token', token); // Store token
        localStorage.setItem('user', JSON.stringify(user)); // Store full user info

        const userLevel = user.user_level;
        localStorage.setItem('user_level', userLevel); 

        onLoginSuccess(userLevel); 

      } else {
        setMessage(result.error?.message || 'Login failed. Please try again.');
        console.error('Login error (backend reported failure):', result.error?.message);
      }
    } catch (error) {
      console.error('Network error during login:', error);
      setMessage('Network error. Could not connect to the server.');
    }
  };

  return (
    <div className="login-container">
      <div className="login-header">
        <img src={`${process.env.PUBLIC_URL}/riberana_logo2.png`} alt="Riberana Logo" className="logo" />
      </div>
      <h2>Ingresar al sistema</h2>

      <form onSubmit={handleSubmit} className="login-form">
        <div className="form-group">
          <label htmlFor="email">Usuario o email:</label>
          <input type="text" id="email" placeholder="Ingresar aqui" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </div>

        <div className="form-group">
          <label htmlFor="password">Contraseña:</label>
          <input type={showPassword ? 'text' : 'password'} id="password" placeholder="Ingresar aqui" value={password} onChange={(e) => setPassword(e.target.value)} required />
          <div className="show-password-container">
            <input type="checkbox" id="showPassword" checked={showPassword} onChange={() => setShowPassword(!showPassword)} />
            <label htmlFor="showPassword">Mostrar contraseña</label>
          </div>
        </div>

        <button type="submit" className="login-button">Login</button>
      </form>

      {message && <p className="login-message">{message}</p>}
    </div>
  );
}

export default Login;